// src/pages/BagsPage.tsx
import React, { useState, useEffect } from 'react';
import { getBags } from '../services/api';
import type { Bag, BagStatus, Company, Dealer } from '../types';

/** What the table shows — satisfied by API bags and by the offline demo rows. */
type BagRow = Pick<Bag, 'bagId' | 'status' | 'farmerName' | 'farmerMobile' | 'weightKg' | 'batchNumber'> & {
  company?: Pick<Company, 'code'>;
  dealer?: Pick<Dealer, 'dealerCode' | 'state'> | null;
};

const DEMO_BAGS: BagRow[] = [
  { bagId:'URA-MH-2024-000001', status:'DELIVERED', farmerName:'Ramesh Kumar', farmerMobile:'9876543210', weightKg:50, batchNumber:'B-2024-06', company:{code:'IFFCO'}, dealer:{dealerCode:'DLR-MH-001',state:'Maharashtra'} },
  { bagId:'URA-MH-2024-000002', status:'PENDING',   farmerName:null,           farmerMobile:null,         weightKg:50, batchNumber:'B-2024-06', company:{code:'IFFCO'}, dealer:{dealerCode:'DLR-MH-001',state:'Maharashtra'} },
  { bagId:'URA-UP-2024-000101', status:'IN_TRANSIT',farmerName:null,           farmerMobile:null,         weightKg:45, batchNumber:'B-2024-05', company:{code:'NFL'},   dealer:{dealerCode:'DLR-UP-001',state:'Uttar Pradesh'} },
  { bagId:'URA-MH-2024-000003', status:'FRAUD',     farmerName:'Ghost Farmer', farmerMobile:'9999999999', weightKg:50, batchNumber:'B-2024-06', company:{code:'IFFCO'}, dealer:{dealerCode:'DLR-MH-001',state:'Maharashtra'} },
];

const STATUS_TAG: Record<BagStatus, string> = { DELIVERED:'tag-green', PENDING:'tag-amber', IN_TRANSIT:'tag-blue', AT_RETAILER:'tag-purple', FRAUD:'tag-red', EXPIRED:'tag-amber' };

export default function BagsPage() {
  const [bags,   setBags]   = useState<BagRow[]>([]);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [loading,setLoading]= useState(true);

  useEffect(() => {
    getBags({ search, status, limit:20 })
      .then(r => setBags(r.data.data))
      .catch(() => setBags(DEMO_BAGS))
      .finally(() => setLoading(false));
  }, [search, status]);

  const statusColor = (s: BagStatus) => STATUS_TAG[s] || 'tag-amber';

  return (
    <>
      <div className="topbar"><div className="topbar-title">📦 Bag Management</div></div>
      <div className="page-content fade-in">
        <div style={{ display:'flex', gap:10, marginBottom:16, flexWrap:'wrap' }}>
          <input style={{ flex:1, minWidth:200, padding:'9px 14px', border:'1.5px solid var(--bor)', borderRadius:9, fontFamily:'DM Sans,sans-serif', fontSize:13, outline:'none' }} placeholder="Search bag ID, farmer, mobile..." value={search} onChange={e=>setSearch(e.target.value)} />
          <select style={{ padding:'9px 14px', border:'1.5px solid var(--bor)', borderRadius:9, fontSize:13, color:'var(--ink)', background:'var(--card)', outline:'none' }} value={status} onChange={e=>setStatus(e.target.value)}>
            <option value="">All Status</option>
            <option value="PENDING">Pending</option>
            <option value="DELIVERED">Delivered</option>
            <option value="IN_TRANSIT">In Transit</option>
            <option value="FRAUD">Fraud</option>
          </select>
        </div>
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          {loading ? <div style={{ padding:40, textAlign:'center' }}><span className="spin">⟳</span></div> : (
            <div className="tbl-scroll">
            <table className="tbl">
              <thead><tr><th>Bag ID</th><th>Company</th><th>Batch</th><th>Wt</th><th>Dealer</th><th>State</th><th>Status</th><th>Farmer</th></tr></thead>
              <tbody>
                {bags.map(b => (
                  <tr key={b.bagId}>
                    <td className="mono" style={{ fontSize:11 }}>{b.bagId}</td>
                    <td style={{ fontSize:12 }}>{b.company?.code}</td>
                    <td className="mono" style={{ fontSize:11 }}>{b.batchNumber}</td>
                    <td style={{ fontSize:12 }}>{b.weightKg}kg</td>
                    <td className="mono" style={{ fontSize:11 }}>{b.dealer?.dealerCode}</td>
                    <td style={{ fontSize:11, color:'var(--ink3)' }}>{b.dealer?.state}</td>
                    <td><span className={`tag ${statusColor(b.status)}`}>{b.status}</span></td>
                    <td style={{ fontSize:12 }}>{b.farmerName||'—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
